import React from 'react';
import logo from "@assets/svg/logo.svg";
import Lottie from "react-lottie";
import noLocation from "@assets/animations/noLocation.json";
import {useTranslation} from "react-i18next";

const NoLocationPermission = () => {
  const {t} = useTranslation();
  return (
    <div className='flex flex-col items-center justify-center align-middle'>
      <img alt="logo" className="mt-10 h-10 my-4" src={logo}/>
      <div className="rounded-md text-center mt-2">
        <h1 className="font-bold text-gray-900 text-xl px-4">
          {t('allowLocationPermissionToBrowserFromMobileSettingsForThisFunctionality')}
        </h1>
        <div className="mt-15 justify-around align-middle mx-9">
          <Lottie
            height={250}
            width={250}
            options={{
              loop: true,
              autoplay: true,
              animationData: noLocation,
              rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
              }
            }}
          />
          <p className="w-full my-5 font-normal text-md text-gray-600">
            {t("inOrderToCheckAvailabilityOfFunctionalityAndProceedWithMenu")}.
          </p>
          <button onClick={() => window.location.reload()}
                  className="mt-7 mb-4 py-4 px-4 text-base group w-full relative justify-center font-medium rounded-3xl text-white bg-gradient-to-r from-cyan-600 from-10% via-sky-800 via-30% to-blue-800 to-90% hover:bg-gradient-to-r hover:from-cyan-600 hover:from-10% hover:via-sky-900 hover:via-30% hover:to-blue-900 to-90 focus:outline-none">
            <div className='text-center'>{t('refresh')}</div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NoLocationPermission;
